.tool-tip {
  --tooltip-arrow-size: 6px;
  --tooltip-background: var(--baseColor-default);
  --tooltip-color: rgba(var(--baseColor-default-reverse-rgb),.85);
  position: absolute;
  display: flex;
  text-align: left;
  line-height: var(--lineHeight-default);
  padding: 1px;
  background: rgba(var(--baseColor-default-reverse-rgb), 0.4);
  border-radius: 2px;
  z-index: var(--layer-9);
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.tool-tip .tooltip-content {
  background: var(--tooltip-background);
  color: var(--tooltip-color);
  font-size: var(--fontSize-small);
  border-radius: 1px;
  padding: 0 4px;
  opacity: 0.9;
}
.tool-tip span {
  line-height: 1.2;
  padding: 3px 0px;
}
.tool-tip span em {
  color: rgba(var(--baseColor-default-reverse-rgb), 0.55);
  font-weight: normal;
  font-style: normal;
  margin-left: 0.5em;
  letter-spacing: 0.1em;
}
.tool-tip span em span {
  letter-spacing: 0;
}
.tool-tip .shortcut {
  margin-left: 10px;
}
.tool-tip .shortcut:empty {
  display: none;
}
.tool-tip.right.corner:before {
  height: 0;
  width: 0;
  display: none;
}
.tool-tip.hidden {
  visibility: hidden;
  display: none;
}
.tool-tip.measure {
  visibility: hidden;
  display: flex;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
}
.tool-tip.visible {
  visibility: visible;
  display: flex;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */